import axios from "axios";
import { Platform } from "react-native";
import handleHTTPError from "utils/handleHTTPError";
import getApiUrl from "./api.services";
import { HTTPMethodParams } from "./types";

// create an axios instance
export const http = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  // request timeout
  timeout: 120000,
});

export const getCsrfToken = () =>
  Platform.OS === "web" ? document.cookie.match(/XSRF-TOKEN=([^;]+)/)?.[1] : "";

// Set post, put default Content-Type
http.defaults.headers.post["Content-Type"] = "application/json";
http.defaults.headers.patch["Content-Type"] = "application/json";
http.defaults.headers.put["Content-Type"] = "application/json";

http.interceptors.request.use(
  async (config) => {
    const baseUrl = await getApiUrl();
    // console.log("base url", baseUrl);

    config.baseURL = baseUrl;
    // for non get methods, append XSRF token to request header
    if (config.method?.toLowerCase() !== "get") {
      const csrfToken = getCsrfToken();
      if (csrfToken) {
        config.headers!["X-XSRF-TOKEN"] = csrfToken;
      }
    }
    // console.log("request config", config);
    // config.headers = {
    //   ...config.headers,
    //   Authorization: `Bearer [INSERT TOKEN HERE]`,
    // };
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const responseInterceptor = (error: any) => {
  // console.log(JSON.stringify(error, null, 2));
  let params = {};
  if (error?.response?.data?.status === 401) {
    if (error.response.data.path.includes("login")) {
      error.response.data.code = "UNAUTHORIZED";
    } else {
      error.response.data.code = "SESSION_EXPIRED";
    }
  }
  if (error?.response?.data?.data) {
    params = error.response.data.data;
  }

  handleHTTPError(error, params);

  return Promise.reject(error);
};

http.interceptors.response.use((response) => {
  // console.log(JSON.stringify(response, null, 2));
  return response;
}, responseInterceptor);

// Encapsulating get method
export function get<T = any>({
  url,
  params,
  paramsSerializer,
  ...rest
}: HTTPMethodParams) {
  return new Promise((resolve, reject) => {
    http
      .get(url, {
        params,
        paramsSerializer,
        ...rest,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  }) as Promise<T>;
}

// Encapsulating post method
export function post<T = any>({ url, params, config }: HTTPMethodParams) {
  return new Promise((resolve, reject) => {
    http
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  }) as Promise<T>;
}

// Encapsulating patch method
export function patch<T = any>({ url, params }: HTTPMethodParams) {
  return new Promise((resolve, reject) => {
    http
      .patch(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  }) as Promise<T>;
}

// Encapsulating patch method
export function put({ url, params }: HTTPMethodParams) {
  return new Promise((resolve, reject) => {
    http
      .put(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}
